import { Button, Col, Form, Input, Row, Typography } from "antd";
import ModalComponent from "../../components/ModalDialog";
import { useWatch } from "antd/es/form/Form";
import React from "react";
const { Text } = Typography;

interface ICreateToolName {
    isNewToolIdModalOpen: boolean
    closeModal: () => void
    addNewToolColumn: (newCol: string) => void
    uniqueToolKeys: any[]
}

const CreateToolName: React.FC<ICreateToolName> = (props) => {

    const { isNewToolIdModalOpen, closeModal, addNewToolColumn, uniqueToolKeys } = props;
    const [form] = Form.useForm();
    
    const toolName = useWatch('tool_name', form);

    const handleOk = () => {
        form.submit();
    };

    const submitForm = () => {
        const value = form.getFieldValue('tool_name').toLowerCase();
        addNewToolColumn(value)
    }

    return (
        <>
            <ModalComponent
                modalWidth="320px"
                title={""}
                visible={isNewToolIdModalOpen}
                cancelText="Cancel"
                onCancel={() => closeModal()}
                okText="Add"
                isMaskClosable={false}
                footer={[
                    <Row key={1} justify={"end"}>
                        <Col className="flex gap-2">
                            <Button type="default" onClick={() => closeModal()} size={"large"}>
                                Cancel
                            </Button>
                            <Button type="primary" disabled={!toolName} onClick={() => handleOk()} size={"large"} htmlType="submit">
                                {"Add"}
                            </Button>
                        </Col>
                    </Row>,
                ]}
            >
                <Form scrollToFirstError form={form} onFinish={submitForm}>

                    <Row className="gap-1">
                        <Col span={24}>
                            <Text className="key-title">Tool Name</Text>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name={"tool_name"}
                                className="m-0 form-items"
                                rules={[
                                    { required: true, message: "Tool Name is required" },
                                    {
                                        validator: (_, value) => {
                                            const isAlreadyExist = uniqueToolKeys?.find((item: any) => item?.trim()?.toLocaleLowerCase() === value?.trim()?.toLocaleLowerCase());
                                            if (isAlreadyExist) {
                                                return Promise.reject("Tool Name already exists");
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input autoComplete="off" placeholder="Enter Tool Name"></Input>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </ModalComponent>
        </>
    )
}

export default CreateToolName;